<template>
  <header class="pa-header pa-header-front pa-front-page-curtain-logo">
    <div class="logo">
      <MainLogo />
    </div>
    <div class="main-curtain">
      <CurtainMain class="main-curtain main-curtain-mobile" />
      <CurtainMainWidely class="main-curtain-widely" />
    </div>
    <div class="side-curtain side-curtain-left">
      <CurtainLeft />
    </div>
    <div class="side-curtain side-curtain-right">
      <CurtainRight />
    </div>
  </header>
</template>

<script>
import MainLogo from '@/components/FrontParts/FrontPageCurtainLogo/Images/logo.svg?inlineF'

import CurtainMain from '@/components/FrontParts/FrontPageCurtainLogo/Images/curtain_main.svg?inlineF'
import CurtainMainWidely from '@/components/FrontParts/FrontPageCurtainLogo/Images/curtain_main_widely.svg?inlineF'

import CurtainLeft from '@/components/FrontParts/FrontPageCurtainLogo/Images/curtain_left.svg?inlineF'
import CurtainRight from '@/components/FrontParts/FrontPageCurtainLogo/Images/curtain_right.svg?inlineF'

export default {
  components : {
    MainLogo,
    CurtainMain,
    CurtainMainWidely,
    CurtainLeft,
    CurtainRight
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";
@import "~bulma/sass/utilities/_all";

.pa-header{
  &-front{
    &.pa-front-page-curtain-logo{
      background:linear-gradient(0deg, $body-background-primary, $body-background-darker);
      position: relative;
      margin-bottom:25px;

      @include from($tablet) {
        min-height:240px;
        margin-bottom:0;
      }

      .logo{
        width:100%;
        position: absolute;
        top:0;
        z-index: 8;
        text-align: center;
        overflow: hidden;

        svg{
          @include mobile {
            max-width:inherit;
            width:110%;
            margin:-10px auto 0 -5%;
          }

          @include from($tablet) {
            margin-top:-25px;
            max-width:750px;
          }
        }
      }

      .side-curtain{
        width:15vw;
        position: absolute;
        z-index: 6;
        top:-3rem;

        @include from($tablet) {
          top:6rem;
          width:20vw;
          max-width:250px;
        }

        @media (max-width:974px) and (min-width:769px) {
          width:16vw;
        }

        &-left{
          left:0;
        }

        &-right{
          right:0;
        }
      }

      .main-curtain{
        position: relative;
        top:0;
        left:0;
        z-index: 7;

        svg.main-curtain{
          @include from($tablet) {
            &-mobile{
              display: none;
            }

            &-widely{
              display: block;
            }
          }

          @include until($tablet) {
            &-mobile{
              display: block;
            }

            &-widely{
              display: none;
            }
          }
        }
      }
    }
  }
}
</style>